import { DuplexLoader } from "components/duplex-loader";
import Icon from "components/icon";
import { twColor } from "@/utils/style";
import { computed, defineComponent, type Ref } from "vue";
import type { UseAssetFormComputedData, UseAssetFormState } from "../types";
import type { UseForm } from "@/form/useForm";
import { AssetImageV2 } from "components/asset-image-v2";

export const AddAssetSaveLoader = defineComponent<{
  progress: Ref<number>;
  form: UseForm<UseAssetFormState, UseAssetFormComputedData>;
}>(
  (props) => {
    const name = computed(() => props.form.state.value.asset.name || "?");

    return () => {
      return (
        <DuplexLoader
          progress={props.progress}
          body={() => {
            return (
              <div class="text-[#111928] text-base font-medium font-['Inter'] leading-normal">
                Adding{" "}
                <span class="text-[#111928] text-base font-semibold font-['Inter'] leading-normal text-primary-500">
                  {name.value}
                </span>{" "}
                {"to portfolio ..."}
              </div>
            );
          }}
          classLeft="bg-gray-100 text-gray-500 grid items-center justify-center text-center"
          left={() => {
            return (
              <AssetImageV2
                asset={props.form.state.value.asset}
                iconProps={{ size: "2rem" }}
                size="l2"
              />
            );
          }}
          classRight="bg-primary-100 text-primary-500"
          right={() => {
            return (
              <Icon
                fill={twColor("primary-500")}
                class="w-[86px] h-[86px] flex items-center justify-center"
                size="3rem"
                src={async () =>
                  import("assets/img/svg/icons/briefcase.svg?raw")
                }
              />
            );
          }}
        />
      );
    };
  },
  { props: ["progress", "form"] },
);
